<!-- <div class="container-fluid">
    <div class="row ">
        <div class="col-lg-4">
        </div>
        <div class="col-lg-4 text-center">
            <h2><b>Stock Override</b></h2>
        </div>
        <div class="col-lg-4">
        </div>
    </div>
</div> -->

<div class="container-fluid">
    <nz-card nzBorderless class="sticky-component" style="border-bottom: 2px solid var(--textcolor); border-radius: 0px; background-color: var(--bodybackgroundcolor);">
        <div nz-row nzJustify="center">
            <div nz-col nzSpan="24" style="padding-bottom: 20px;">
                <div id="btnfunctions" class="text-center">
                    <button nz-button nzType="primary" (click)="onClickAddNewRule()" style="margin-left: 10px; margin-right: 10px;">
                        <span nz-icon nzType="file-add" nzTheme="outline"></span>
                    Add New Rule
                    </button>
                    <button nz-button nzType="primary" (click)="exportexcel()" style="margin-left: 10px; margin-right: 10px;">
                        <span nz-icon nzType="file-excel" nzTheme="outline"></span>
                    Download To Excel
                    </button>
                </div>
            </div>
            <div nz-col nzSpan="8">
                <nz-input-group nzSuffixIcon="search">
                    <input type="text" nz-input placeholder="Filter Override Pricing" [(ngModel)]="overrideFilter" (ngModelChange)="resetTable()"/>
                </nz-input-group>
            </div>
        </div>
    </nz-card>
    <!-- <div nz-col nzSpan="24"> -->
        <p></p>
        <nz-table [nzData]="this.overrideData" #stockTable [nzFrontPagination]="false" id="tbl" [nzLoading]="isLoading">
            <thead>
                <tr class="sticky-header">
                    <th [nzSortFn]="fnSortBrand">Brand</th>
                    <th [nzSortFn]="fnSortStockCode">Stock Code</th>
                    <th [nzSortFn]="fnSortDescription">Description</th>
                    <th [nzSortFn]="fnSortDate">Date Created</th>
                    <th>{{ this.pricelist.plonline }}</th>
                    <th>{{ this.pricelist.plretail }}</th>
                    <th>{{ this.pricelist.deflt }}</th>
                    <th>{{ this.pricelist.wholesale }}</th>
                    <th>{{ this.pricelist.plinternal }}</th>
                    <th>{{ this.pricelist.plclear}}</th>
                    <th>{{ this.pricelist.plcustom1 }}</th>
                    <th>{{ this.pricelist.plcustom2 }}</th>
                    <th>{{ this.pricelist.plcustom3 }}</th>
                    <th>{{ this.pricelist.plcustom4 }}</th>
                    <th>Action </th>
                    <th><app-video-widget [videoId]="20" style="float: inline-end;"></app-video-widget></th>
                </tr>
            </thead>
            <tbody class="tbody">
                <tr *ngFor="let item of stockTable.data | filter: overrideFilter: overrideFilterArray: 0: pageSize">
                    <ng-container *ngIf="!editCache[item.overindex].edit; else editTemplate">
                        <td>{{item.brand}}</td>
                        <td><span style="margin-left: 5px;">{{item.stock_code}}</span></td>
                        <td class="description"><span>{{ item.description }}</span> </td>
                        <td  [style.color]="getDateColor(item.dateCreated)">{{item.dateCreated | date:'mediumDate'}}</td>
                        <td><span *ngIf="item.plonline == null"> - </span><span *ngIf="item.plonline != null">{{ item.plonline }}</span></td>
                        <td><span *ngIf="item.plretail  == null"> - </span><span *ngIf="item.plretail != null">{{ item.plretail }}</span></td>
                        <td><span *ngIf="item.deflt  == null"> - </span><span *ngIf="item.deflt != null">{{ item.deflt }}</span></td>
                        <td><span *ngIf="item.wholesale == null"> - </span><span *ngIf="item.wholesale != null">{{ item.wholesale }}</span></td>
                        <td><span *ngIf="item.plinternal == null"> - </span><span *ngIf="item.plinternal != null">{{ item.plinternal }}</span></td>
                        <td><span *ngIf="item.plclear == null"> - </span><span *ngIf="item.plclear != null"> {{ item.plclear }}</span></td>
                        <td><span *ngIf="item.plcustom1  == null"> - </span><span *ngIf="item.plcustom1 != null">{{ item.plcustom1 }}</span></td>
                        <td><span *ngIf="item.plcustom2 == null"> - </span><span *ngIf="item.plcustom2  != null">{{ item.plcustom2 }}</span></td>
                        <td><span *ngIf="item.plcustom3 == null"> - </span><span *ngIf="item.plcustom3 != null">{{ item.plcustom3 }}</span></td>
                        <td><span *ngIf="item.plcustom4 == null"> - </span><span *ngIf="item.plcustom4 != null"> {{ item.plcustom4 }}</span></td>
                        <td [colSpan]="2">
                            <nz-button-group nzSize="large">
                                <button nz-button nzType="primary" nzSize="large" (click)="startEdit(item.overindex)" nz-tooltip nzTooltipTitle="Edit">
                                    <span nz-icon nzType="edit" nzTheme="fill"></span>
                                </button>
                                <button nz-button nzType="default" nzSize="large" nzDanger nzBorderless (click)="removeRule(item)" nz-tooltip nzTooltipTitle="Delete">
                                    <span nz-icon nzType="delete" nzTheme="fill"></span>
                                </button>
                            </nz-button-group>
                        </td>
                    </ng-container>
                    <ng-template #editTemplate>
                        <td>{{item.brand}}</td>
                        <td><span style="margin-left: 5px;">{{item.stock_code}}</span></td>
                        <td class="description"><span>{{ item.description }}</span></td>
                        <td  [style.color]="getDateColor(item.dateCreated)">{{item.dateCreated | date:'mediumDate'}}</td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plonline"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plretail"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.deflt"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.wholesale"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plinternal"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plclear"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plcustom1"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plcustom2"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plcustom3"></td>
                        <td><input type="number" nz-input [(ngModel)]="editCache[item.overindex].data.plcustom4"></td>
                        <td>
                            <nz-button-group nzSize="large">
                                <button nz-button nzType="primary" nzSize="large" (click)="saveEdit(item.overindex)" nz-tooltip nzTooltipTitle="Save" [disabled]="duplicationCheck(item)">
                                    <span nz-icon nzType="check" nzTheme="outline"></span>
                                </button>
                                <button nz-button nzType="default" nzSize="large" nzBorderless (click)="cancelEdit(item.overindex)" nz-tooltip nzTooltipTitle="Cancel">
                                    <span nz-icon nzType="close" nzTheme="outline"></span>
                                </button>
                            </nz-button-group>
                        </td>
                    </ng-template>
                </tr>
            </tbody>
        </nz-table>
    <!-- </div> -->
</div>

<nz-modal [(nzVisible)]="isAddModalVisible" nzClosable="true" nzTitle="Add New Rule" (nzOnCancel)="isAddModalVisible = false;" (nzOnOk)="addRule()" [nzFooter]="null" nzSize="large" nzWidth="100%">
    <div *nzModalContent class="text-center">
        <div class="container-fluid">
            <div nz-row>
                <div nz-col nzSpan="24">
                    <div  style="float: left">
                        <p style="font-size: x-small;">*Please note override pricing can only be applied to tyre stock</p>
                    </div>
                </div>
                <div nz-col nzSpan="24">
                    <div  style="float: right">
                        <span>Show non active stock: </span>
                        <nz-switch [(ngModel)]="showNonActiveStock"></nz-switch>
                    </div>
                </div>
            </div>
            <br>
            <div nz-row nzJustify="center" nzAlign="middle">
                <div nz-col nzSpan="17">
                    <nz-select 
                    [(ngModel)]="msfid"  
                    style="width: 100%;" 
                    [nzMode]="'tags'"
                    nzAllowClear
                    nzPlaceHolder="Please Select Stock Codes"
                    nzShowSearch
                    [nzFilterOption]="customFilter"
                    [nzTokenSeparators]="[',', ', ']"
                    (nzOnSearch)="filterStock($event)"
                    (nzScrollToBottom)="loadMore()">
                        <nz-option *ngFor="let option of tempStockInfo" nzCustomContent  [nzLabel]="option.descriptionFull" [nzValue]="option.stockcode">
                            <span>{{ option.descriptionFull }}</span>
                            <span *ngIf="option.activeId === 0" style="color: var(--textcolor)"> NON ACTIVE STOCK</span>
                        </nz-option>
                    </nz-select>
                </div>
                <div nz-col nzSpan="1">
                    <span nz-icon nzType="question-circle" nzTheme="outline" class="color-primary" style="font-size: 1.5rem !important;" nz-tooltip='To add multiple items simultaneously. Copy and paste stock codes seperated with a comma. E.g. "RK1981H1,R10551085D1,0450665,"'></span>
                </div>
                <div nz-col nzSpan="6">
                    <button nz-button nzType="primary" (click)="addOverRideStock()">Add Stock</button>
                </div>
            </div>
            <br>
            <div nz-row [nzJustify]="'space-evenly'" nzAlign="middle">
                <div nz-col nzSpan="16">
                    <nz-radio-group [(ngModel)]="marginType">
                        <label nz-radio [nzValue]="1">Retail Less</label>
                        <label nz-radio [nzValue]="2">Cost Plus</label>
                        <label nz-radio [nzValue]="3">Branch Cost Plus</label>
                    </nz-radio-group>
                </div>
                <div nz-col nzSpan="2">
                    <nz-input-group nzSuffix="%">
                        <input type="number" nz-input placeholder="Add Margin %" [(ngModel)]="overrideMargin"   min="0" max="100"/>
                    </nz-input-group>
                </div>
                <div nz-col nzSpan="6">
                    <button nz-button nzType="default" (click)="updateColumnMargins()">Apply Margin</button>
                    <button nz-button nzType="default" (click)="resetColumnMargins()" style="margin-left: 8px;">Reset Margin</button>
                </div>
            </div>
            <br>
        </div>
        <div>
            <nz-table [nzData]="this.overrideAddTable" #stockAddTable nzFrontPagination="false">
                <thead>
                    <tr>
                        <th>Brand</th>
                        <th>Stock Code</th>
                        <th>Description</th>
                        <th>List Price</th>
                        <th>Cost</th>
                        <th>Branch Cost</th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceOnline'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plonline }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceRetail'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plretail }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceDefault'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.deflt }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceWholesale'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.wholesale }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceInternal'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plinternal }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceClearout'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plclear}}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceCustom1'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plcustom1 }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceCustom2'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plcustom2 }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceCustom3'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plcustom3 }}
                            </th>
                            <th>
                                <nz-radio-group [(ngModel)]="priceType">
                                <label nz-radio [nzValue]="'overRidePriceCustom4'"></label>
                            </nz-radio-group>
                            {{ this.pricelist.plcustom4 }}
                            </th>
                    </tr>
                </thead>
                <tbody class="tbody">
                    <tr *ngFor="let item of stockAddTable.data">
                        <td>{{item.brand}}</td>
                        <td><span style="margin-left: 5px;">{{item.stockcode}}</span></td>
                        <td class="description"><span>{{ item.description }}</span> </td>
                        <td><span *ngIf="item.retail == null"> - </span><span *ngIf="item.retail != null">{{ item.retail }}</span></td>
                        <td><span *ngIf="item.cost == null"> - </span><span *ngIf="item.cost != null">{{ item.cost }}</span></td>
                        <td><span *ngIf="item.branchCost == null"> - </span><span *ngIf="item.branchCost != null">{{ item.branchCost }}</span></td>
                        <td>
                            <input type="number" [placeholder]="item.priceonline ? item.priceonline : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceOnline" (ngModelChange)="priceIn = (item.overRidePriceOnline!)" (focus)="priceIn = item.overRidePriceOnline!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.priceretail ? item.priceretail : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceRetail" (ngModelChange)="priceIn = item.overRidePriceRetail!" (focus)="priceIn = item.overRidePriceRetail!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.pricedefault ? item.pricedefault : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceDefault" (ngModelChange)="priceIn = item.overRidePriceDefault!" (focus)="priceIn = item.overRidePriceDefault!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.pricewholesale ? item.pricewholesale : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceWholesale" (ngModelChange)="priceIn = item.overRidePriceWholesale!" (focus)="priceIn = item.overRidePriceWholesale!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.priceinternal ? item.priceinternal : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceInternal" (ngModelChange)="priceIn = item.overRidePriceInternal!" (focus)="priceIn = item.overRidePriceInternal!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.priceclearout ? item.priceclearout : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceClearout" (ngModelChange)="priceIn = item.overRidePriceClearout!" (focus)="priceIn = item.overRidePriceClearout!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.pricecustom1 ? item.pricecustom1 : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceCustom1" (ngModelChange)="priceIn = item.overRidePriceCustom1!" (focus)="priceIn = item.overRidePriceCustom1!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.pricecustom2 ? item.pricecustom2 : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceCustom2" (ngModelChange)="priceIn = item.overRidePriceCustom2!" (focus)="priceIn = item.overRidePriceCustom2!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.pricecustom3 ? item.pricecustom3 : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceCustom3" (ngModelChange)="priceIn = item.overRidePriceCustom3!" (focus)="priceIn = item.overRidePriceCustom3!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <td>
                            <input type="number" [placeholder]="item.pricecustom4 ? item.pricecustom4 : '-'" nz-input nz-popover nzPopoverTitle="Margins" [nzPopoverContent]="priceTemplate" [(ngModel)]="item.overRidePriceCustom4" (ngModelChange)="priceIn = item.overRidePriceCustom4!" (focus)="priceIn = item.overRidePriceCustom4!" [nzPopoverTrigger]="'focus'">
                        </td>
                        <ng-template #priceTemplate let-data>
                            <span>{{data}}</span>
                            <b>Retail Less:</b><p>{{calculateRetailPrice(item.retail) | percent: '1.2-2'}}</p>
                            <b>Cost Plus:</b><p>{{calculateCost(item.cost) | percent: '1.2-2'}}</p>
                            <b>Branch Cost Plus:</b><p>{{calculateBranchCost(item.branchCost) | percent: '1.2-2'}}</p>
                        </ng-template>
                    </tr>
                </tbody>
            </nz-table>
            <br>
            <div class="container-fluid">
                <div nz-row>
                    <div nz-col nzSpan="12" class="text-center offset-3">
                        <button nz-button nzType="primary" (click)="addRule()" [disabled]="overrideAddTable.length === 0">
                            <span nz-icon nzType="plus" nzTheme="outline"></span>
                            Add Rule<span *ngIf="overrideAddTable.length > 1">s</span>
                    </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nz-modal>